const MANUAL_AUTH_CALLBACK_PATHS = new Set([
  '/auth/callback',
  '/auth/verify',
  '/auth/native-callback',
]);

export function shouldDetectSessionInUrl(options: {
  isBrowser: boolean;
  pathname?: string | null;
}): boolean {
  if (!options.isBrowser) {
    return false;
  }

  const pathname = options.pathname?.trim();
  if (!pathname) {
    return true;
  }

  return !MANUAL_AUTH_CALLBACK_PATHS.has(pathname);
}
